import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
interface Props {
  fontSizeClass?: string;
}
export default function MuteStatusChat(props) {
  const $ = _c(5);
  const {
    fontSizeClass
  } = props;
  let t0;
  if ($[0] !== fontSizeClass) {
    t0 = cn("mb-[3px] whitespace-pre-wrap text-cht_al_2", fontSizeClass);
    $[0] = fontSizeClass;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>{"\uCC44\uD305\uAE08\uC9C0 \uC0C1\uD0DC\uC785\uB2C8\uB2E4."}</div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <div className={t0}>{t1}</div>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}